import { useTheme } from "@emotion/react";
import { ChartData } from "chart.js";
import React from "react";
import { Bar } from "react-chartjs-2";
import tinycolor from "tinycolor2";

import { withCubeHomeChartScrollPassthrough } from "./cubeChartOptions";
import { CubeExpandableChartFrame } from "./CubeExpandableChartFrame";
import type { ProContractorRow } from "./parseProContractorRows";
import { buildStackedRegionDatasets } from "./proContractorsAggregate";

type Props = {
  rows: ProContractorRow[];
};

export const ProContractorsStackedBarChart: React.FC<Props> = ({ rows }) => {
  const theme = useTheme();
  const { labels, datasets } = buildStackedRegionDatasets(rows);
  const palette = datasets.map((_, i) =>
    tinycolor(theme.colors.primary)
      .spin(i * 38)
      .lighten((i % 4) * 3)
      .toHexString(),
  );
  const data: ChartData<"bar"> = {
    labels,
    datasets: datasets.map((ds, i) => ({
      ...ds,
      backgroundColor: palette[i % palette.length],
      borderColor: palette[i % palette.length],
    })),
  };
  const options = withCubeHomeChartScrollPassthrough<"bar">({
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      x: { stacked: true },
      y: { stacked: true, beginAtZero: true, ticks: { stepSize: 1 } },
    },
    plugins: {
      legend: { position: "top" },
    },
  });
  return (
    <CubeExpandableChartFrame modalTitle="Nowi wykonawcy PRO" embedHeightPx={320}>
      {({ containerCss }) => (
        <div css={containerCss}>
          <Bar data={data} options={options} />
        </div>
      )}
    </CubeExpandableChartFrame>
  );
};
